export default "__VITE_ASSET__CT7E2EkR__"